export const RESCIND = 'RESCIND';
export const BINDER_EXPIRED = 'BINDER EXPIRED';
export const BOUND = 'BOUND';

export const BinderStatus = {
  BINDER_EXPIRED,
  BOUND,
  RESCIND,
} as const;

export type BINDER_STATUS = (typeof BinderStatus)[keyof typeof BinderStatus];
